<ng-container *transloco="let t">
  <div class="card">

    <div class="card-header">
      <ng-content select="[title]"></ng-content>
    </div>

    <h2>{{ t('common.labels.filters') }}</h2>
    <ng-content select="[filter]"></ng-content>
    <hr />

    <app-loader [loading]="loading"></app-loader>
    <ng-content *ngIf="loading !== true" select="[details]"></ng-content>

  </div>
</ng-container>
